module.exports = __webpack_public_path__ + "img/JPG_picture_icon@2x.a5a5075f.png";